//#region src/promotion_threshold_type.ts
var PromotionThresholdType = /* @__PURE__ */ function(PromotionThresholdType) {
	PromotionThresholdType["CartValue"] = "cart-value";
	PromotionThresholdType["CartSize"] = "cart-size";
	return PromotionThresholdType;
}(PromotionThresholdType || {});
//#endregion
export { PromotionThresholdType };

//# sourceMappingURL=promotion_threshold_type.js.map